import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import BgImg from "../../../images/case-studies/mocuts/concept_back.webp";

function Clients() {
  return (
    <div
      className="client_expectations concept_mocuts p-100 text_mocuts"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="ms-auto my-auto">
            <h2>
              The Concept Behind <span>MoCuts Pro</span>
            </h2>
            <p>
              The client wanted to gather barbers and beauticians on a single
              online platform to help people book the slots online according to
              their schedule and get a haircut and other related services in
              their homes.
            </p>
            <p>
              The concept behind this on-demand barber service app is to
              eliminate the need to go to salons and wait for your turn. All the
              barbers and beauticians on MoCuts Pro must register and get
              verified by the platform. At the same time, the buyers need to
              sign up and create a user profile to start ordering services.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Clients;
